export const NEWS_CATEGORY_OPTIONS = [
  {
    value: "announcements",
    label: "Announcements",
    cardColor: "#2E3883",
  },
  {
    value: "media_coverage",
    label: "Media Coverage",
    cardColor: "#176EB7",
  },
  {
    value: "korean_news",
    label: "Korean News",
    cardColor: "#176EB7",
  },
  {
    value: "publications",
    label: "Publications",
    cardColor: "#5AB8FF",
  },
];

export const NEWS_ALL_CATEGORY = {
  value: "all",
  label: "All",
};

const categoryMap = NEWS_CATEGORY_OPTIONS.reduce((acc, category) => {
  acc[category.value] = category;
  return acc;
}, {});

export function getNewsCategoryLabel(type) {
  return categoryMap[type]?.label ?? "Unknown";
}

export function getNewsCategoryColor(type) {
  return categoryMap[type]?.cardColor ?? "#2E3883";
}
